export default __webpack_public_path__ + "static/media/step2_jack.422cf51d.png";